'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoOpenCreateAccountModal = exports.shouldPopModal = exports.shouldStopAutoPopup = exports.getUiModalShown = exports.getUiHasLoggedInBefore = exports.getUiDateLastShown = exports.DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN = exports.AUTO_POP_MODAL_SUCCESS = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = require('./modal');

var _reselect = require('reselect');

var _client = require('./client');

var _login = require('./login');

var _enums = require('../../enums');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _passwordReset = require('./passwordReset');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var AUTO_POP_MODAL_SUCCESS = exports.AUTO_POP_MODAL_SUCCESS = 'la/ui/autoPopModal/SUCCESS';
var DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN = exports.DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN = 7;

// reducer
var DEFAULT_STATE = {
    dateLastShown: '',
    disableModalForTesting: false,
    hasLoggedInBefore: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case AUTO_POP_MODAL_SUCCESS:
            return (0, _extends3.default)({}, state, {
                dateLastShown: action.payload
            });
        case _login.LOGIN_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            return (0, _extends3.default)({}, state, {
                hasLoggedInBefore: true
            });
        case _client.HYDRATE_CLIENT_STATE:
            return (0, _extends3.default)({}, state, {
                dateLastShown: action.payload.dateLastShown,
                hasLoggedInBefore: action.payload.hasLoggedInBefore
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.autoPopModal;
};
var getUiDateLastShown = exports.getUiDateLastShown = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.dateLastShown;
});
var getUiHasLoggedInBefore = exports.getUiHasLoggedInBefore = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.hasLoggedInBefore;
});
var getUiModalShown = exports.getUiModalShown = (0, _reselect.createSelector)(getUiDateLastShown, function (date) {
    return !!date;
});
var shouldStopAutoPopup = exports.shouldStopAutoPopup = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.disableModalForTesting;
});

var shouldPopModal = exports.shouldPopModal = (0, _reselect.createSelector)([shouldStopAutoPopup, _modal.getOpenModal, getUiDateLastShown, getUiModalShown, getUiHasLoggedInBefore], function (abort, openModal, dateLastShown, hasSeenModal, hasLoggedInBefore) {
    if (abort) return false;

    var seenMoreThanCertainNumber = false;
    if (!!dateLastShown) {
        var now = (0, _momentTimezone2.default)();
        var difference = (0, _momentTimezone2.default)(dateLastShown).diff(now, 'days') * -1;
        seenMoreThanCertainNumber = difference >= DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN;
    }
    var popModal = (!hasSeenModal || seenMoreThanCertainNumber) && !hasLoggedInBefore && openModal === _enums.modalTypes.NONE;
    return popModal;
});

/* ACTION CREATORS */
var autoOpenCreateAccountModal = exports.autoOpenCreateAccountModal = function autoOpenCreateAccountModal() {
    return function (dispatch, getState) {
        var state = getState();
        if (shouldPopModal(state)) {
            return _promise2.default.all([dispatch({
                payload: (0, _momentTimezone2.default)(new Date()).format('YYYY-MM-DD'),
                type: AUTO_POP_MODAL_SUCCESS
            }), dispatch((0, _modal.openCreateAccountModal)())]);
        } else {
            return _promise2.default.resolve({});
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/autoPopModal.js
// module id = GvHb
// module chunks = 60